import ChooseContact from "components/AddresseePicker/ChooseContact";
import LabelledDivRow from "components/LabelledDivRow";
import PromoterModalPicker from "components/Picker/PromoterPicker/PromoterModalPicker";
import { useModals } from "Modals/ModalsProvider";
import React from "react";

interface Props {
  company: server.dto.CompanySmall
  onCompanyChange: (company: server.dto.CompanySmall) => void

  contact: server.dto.ContactSmallV2
  onContactChange: (contact: server.dto.ContactSmallV2) => void
}

const PromoterPanel = (props: Props) => {
  const hasPromoter = props.company != null;

  const modals = useModals();

  const onCompanyChange = async (company: server.dto.CompanySmall) => {
    if (company) {
      modals.displayFinancialRiskModal(company.companyId);
    }

    props.onCompanyChange(company);
    props.onContactChange(null);
  };

  return <LabelledDivRow label={site.currentEnvironment.functionGroups.promoter.singular}>
    <div>
      <PromoterModalPicker
        afterCreate="closeSidebar"
        canCreateNew={true}
        nonInPageEditing={{
          onChange: onCompanyChange,
          value: props.company,
          validatorKey: "promoter",
          required: false,
        }}
      />
    </div>
    {hasPromoter && <div className="flex-column gap-small">
      <ChooseContact
        companyId={props.company.companyId}
        selectedContact={props.contact}
        onContactChanged={props.onContactChange}
      />
    </div>}
  </LabelledDivRow>;
};

export default PromoterPanel;
